export default __webpack_public_path__ + "static/lifetime-tasks-75606a80743288eb395ce4cee17f54db.jpg";